// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2231":"8bfe697d","3853":"8bfe697d","3976":"20427526","5656":"dfa4f69d"}[chunkId] + ".chunk.css";
};